module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.237f4a0a.woff2";